import React from "react";
import { Offcanvas, Badge, Card, Row, Col } from "react-bootstrap";
import { FaCheck, FaTimes, FaInfoCircle, FaUser, FaClock, FaShieldAlt } from "react-icons/fa";

const AuditDetail = ({ Show, Hide, Title, auditData }) => {
  const audit = auditData || {
    id: "AUD-0001",
    ts: "20 Jun 2026, 14:30:22",
    user: "Dr. A. Mendoza",
    role: "Clinical Project Manager",
    entity: "Subject",
    action: "Randomized",
    detail: "102-006 (R0006) · schema RS-001 · ver v1.0 · [blinded]",
    prev: "Eligible",
    next: "Randomized",
    reason: "",
    esig: true,
    sys: false,
    ip: "10.0.0.45",
    category: "Subject Management",
  };

  const StatusBadge = ({ esig, sys }) => {
    if (esig) {
      return (
        <Badge className="bg-success d-flex align-items-center gap-1">
          <FaCheck size={16} />
          e-Signature
        </Badge>
      );
    } else if (sys) {
      return (
        <Badge className="bg-secondary d-flex align-items-center gap-1">
          <FaInfoCircle size={16} />
          System Event
        </Badge>
      );
    }
    return (
      <Badge className="bg-light text-secondary d-flex align-items-center gap-1">
        <FaTimes size={16} />
        Not Signed
      </Badge>
    );
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || `Audit Record ${audit.id}`}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 className="mb-1">{audit.action}</h5>
            <span className="text-muted small">{audit.id}</span>
          </div>
          <StatusBadge esig={audit.esig} sys={audit.sys} />
        </div>

        {/* Record Details */}
        <Card className="mb-3">
          <Card.Body className="p-3">
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              RECORD DETAILS
            </h6>
            
            <div className="row mb-2">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  <FaClock className="me-1" size={12} />
                  Timestamp
                </span>
              </div>
              <div className="col-8">
                <small>{audit.ts}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  <FaUser className="me-1" size={12} />
                  User / Role
                </span>
              </div>
              <div className="col-8">
                <small>{audit.user}</small>
                <div className="text-muted small">{audit.role}</div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  <FaShieldAlt className="me-1" size={12} />
                  Entity
                </span>
              </div>
              <div className="col-8">
                <small>{audit.entity}</small>
                {audit.category && (
                  <Badge className="bg-secondary bg-opacity-10 text-secondary ms-2">
                    {audit.category}
                  </Badge>
                )}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  Action
                </span>
              </div>
              <div className="col-8">
                <small>{audit.action}</small>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  IP Address
                </span>
              </div>
              <div className="col-8">
                <small>{audit.ip}</small>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Change Details */}
        <Card className="mb-3">
          <Card.Body className="p-3">
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              CHANGE DETAILS
            </h6>
            
            <div className="row mb-2">
              <div className="col-4">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>
                  Detail
                </span>
              </div>
              <div className="col-8">
                <small>{audit.detail}</small>
              </div>
            </div>

            {audit.prev && audit.next && (
              <div className="row mb-2">
                <div className="col-4">
                  <span style={{ fontSize: "13px", color: "#6c757d" }}>
                    Change
                  </span>
                </div>
                <div className="col-8">
                  <span className="text-danger ">{audit.prev}</span>
                  <span className="mx-2 text-muted">→</span>
                  <span className="text-success ">{audit.next}</span>
                </div>
              </div>
            )}

            {audit.reason && (
              <div className="row">
                <div className="col-4">
                  <span style={{ fontSize: "13px", color: "#6c757d" }}>
                    Reason
                  </span>
                </div>
                <div className="col-8">
                  <small>{audit.reason}</small>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>

        {/* Compliance Status */}
        <Card>
          <Card.Body className="p-3">
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              COMPLIANCE STATUS
            </h6>
            <Row>
              <Col xs={6}>
                <div className="text-muted small">Electronic Signature</div>
                <div className="">
                  {audit.esig ? (
                    <span className="text-success">
                      <FaCheck className="me-1" /> Signed
                    </span>
                  ) : audit.sys ? (
                    <span className="text-secondary">
                      <FaInfoCircle className="me-1" /> System
                    </span>
                  ) : (
                    <span className="text-muted">Not Required</span>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <div className="text-muted small">Timestamp Integrity</div>
                <div className=" text-success">
                  <FaCheck className="me-1" /> Verified
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top d-flex justify-content-end">
        <button className="updateProfile" onClick={Hide}>
          Close
        </button>
      </div>
    </Offcanvas>
  );
};

export default AuditDetail;